import React from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CloseFeeWindowDescription from './CloseFeeWindowDescription';
import EditFeeWindowDescription from './EditFeeWindowDescription';
import FreelancerFeeSearchParams from './FreelancerFeeSearchParams';
import GeneralSearchStrip from '../../../Elements/GeneralSearchStrip';

class FeePanels extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shownPanel: props.shownPanel
    };
    this.showPanel = this.showPanel.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (this.state.shownPanel !== this.props.shownPanel) {
        this.setState({ shownPanel: this.props.shownPanel });
      }
    }
  }

  showPanel(panelId) {
    let newPanelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.props.changeShownPanel(newPanelId);
    this.setState({
      shownPanel: newPanelId
    });
  }

  renderButtons() {
    return (
      // <ButtonRow
      //     labels={["Search",]}
      //     keys={[ShownPanelsEnum.Search,]}
      //     icons={["fa-solid fa-search",]}
      //     value={this.state.shownPanel}
      //     onClick={this.showPanel}
      // />
      ''
    );
  }

  renderPanels() {
    switch (this.state.shownPanel) {
      case ShownPanelsEnum.AddNewItem:
        // This panel is only ever reached via FreelancerFeeItem.cloneThisFeeFunction (there is no
        // standalone "create a fee" entry point in this admin - that lives in FreelancerUserAdmin).
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={EditFeeWindowDescription.buildItemForClone(this.props.selectedItem)}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={(edited, result) => this.props.clickOnOk(ShownPanelsEnum.EditItem, edited, result)}
            windowDescription={EditFeeWindowDescription}
            errorCode='FEE-CLONE'
          />
        );
      case ShownPanelsEnum.Search:
        return (
          <GeneralSearchStrip
            searchItem={this.props.searchItem}
            searchparamsType={FreelancerFeeSearchParams}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnOk={this.props.clickOnOk}
          />
        );
      case ShownPanelsEnum.EditItem:
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={EditFeeWindowDescription.buildItemForEdit(this.props.selectedItem)}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={(edited, result) => this.props.clickOnOk(ShownPanelsEnum.EditItem, edited, result)}
            windowDescription={EditFeeWindowDescription}
            errorCode='FEE-EDIT'
          />
        );
      case ShownPanelsEnum.Close:
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={{ ...this.props.selectedItem, EndDate: new Date() }}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={(edited, result) => this.props.clickOnOk(ShownPanelsEnum.Close, edited, result)}
            windowDescription={CloseFeeWindowDescription}
            errorCode='FEE-CLOSE'
          />
        );
      default:
        return null;
    }
  }

  render() {
    return (
      <div className='w-100'>
        {this.renderButtons()}
        {this.renderPanels()}
      </div>
    );
  }
}

export default FeePanels;
